export default __webpack_public_path__ + "static/media/card-product2.8f6aacd7.jpg";